import { useEffect, useRef } from "react";
import { useToast } from "@/components/ui/use-toast";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast";

export function Toaster() {
  const { toasts, dismiss } = useToast();

  // This Toast is a plain component (not Radix), so closing and auto-dismiss are handled here.
  const scheduled = useRef(new Set());
  useEffect(() => {
    toasts.forEach((t) => {
      if (t.open === false || scheduled.current.has(t.id)) return;
      scheduled.current.add(t.id);
      setTimeout(() => dismiss(t.id), t.duration ?? 7000);
    });
  }, [toasts, dismiss]);

  return (
    <ToastProvider>
      {toasts.filter((t) => t.open !== false).map(function ({ id, title, description, action, open, onOpenChange, duration, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose onClick={() => dismiss(id)} className="opacity-100" aria-label="Close" />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
} 